import { useEffect, useRef, useState } from "react";

const useResendOtp = (textRef) => {
  const minRef = useRef(0);
  const secRef = useRef(30);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    let interval = null;
    if (secRef.current > 0 || minRef.current > 0) {
      interval = setInterval(() => {
        if (secRef?.current > 0) {
          secRef.current = secRef?.current - 1;
          if (textRef.current) {
            textRef.current.innerHTML = `You can resend OTP in ${minRef.current}:<span>${secRef.current.toString().padStart(2, '0')}</span> Seconds`;
          }
        } else if (secRef?.current === 0 && minRef.current > 0) {
          minRef.current = minRef?.current - 1;
          secRef.current = 30;
        } else {
          textRef.current.innerHTML = "Resend OTP";
          clearInterval(interval);
          setCanResend(true);
        }
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [secRef.current, minRef.current, canResend, textRef]);

  const resetTimer = () => {
    minRef.current = 0;
    secRef.current = 30;
    setCanResend(false);
  };

  return { canResend, resetTimer };
};

export default useResendOtp;
